/*
 * Default text labels.
 */
const getTextLabels = () => ({
  body: {
    noMatch: 'Lo sentimos, no se encontraron registros coincidentes',
    toolTip: 'Ordenar'
  },
  pagination: {
    next: 'Página siguiente',
    previous: 'Página anterior',
    rowsPerPage: 'Filas por página:',
    displayRows: 'de'
  },
  toolbar: {
    search: 'Buscar',
    downloadCsv: 'Descargar CSV',
    print: 'Imprimir',
    viewColumns: 'Ver columnas',
    filterTable: 'Tabla de filtros'
  },
  filter: {
    all: 'Todos',
    title: 'Filtros',
    reset: 'Restablecer'
  },
  viewColumns: {
    title: 'Mostrar columnas',
    titleAria: 'Mostrar / Ocultar columnas de tabla'
  },
  selectedRows: {
    text: 'fila (s) seleccionada (s)',
    delete: 'Eliminar',
    deleteAria: 'Eliminar filas seleccionadas'
  }
})

export default getTextLabels
